import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { Link } from 'react-router-dom-v5-compat'

import CustomTooltip from '@/app/component/atom/tooltip'
import { Balance as TBalance } from '@/app/types'

type Props = {
  balance?: TBalance
  balanceIsBelowNotificationAmount: boolean
}

const OrgBalance: React.FC<Props> = ({ balance, balanceIsBelowNotificationAmount }) => (
  <Container>
    <CustomTooltip title="Add funds">
      <BalancePanel id="account-balance" to="/billing" warn={balanceIsBelowNotificationAmount}>
        <BalanceWrap color="inherit">
          {balance?.balanceHuman && (
            <>
              <BalanceItem style={{ marginRight: '0.25rem' }}>$</BalanceItem>
              <BalanceItem id="org-balance">{balance.balanceHuman}</BalanceItem>
            </>
          )}
          {!balance?.balanceHuman && <BalanceItem id="org-balance">N/A</BalanceItem>}
        </BalanceWrap>
      </BalancePanel>
    </CustomTooltip>
  </Container>
)

const Container = styled('div')({
  display: 'flex',
})

const BalancePanel = styled(Link, { shouldForwardProp: (prop) => prop !== 'warn' })<{
  warn: boolean
}>(({ theme, warn }) => ({
  height: '64px',
  marginRight: '0.5rem',
  padding: '0 0.5rem',
  color: 'inherit',
  textDecoration: 'none',
  cursor: 'pointer',
  backgroundColor: warn ? theme.palette.error.light : theme.palette.primary.dark,
  minWidth: 80,
}))

const BalanceWrap = styled(Typography)({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
})

const BalanceItem = styled('span')({
  display: 'flex',
  fontSize: '1rem',
  alignItems: 'center',
  fontWeight: 'bold',
})

export default OrgBalance
